import React from "react"
import Section from "./section"
import CConsentBanner from "../elements/c_consent_banner"

const MPowerBi = ({ data }) => {
  const { path_segment } = data

  return (
    <Section baseClass="m-PowerBi" defaultPadding="large" data={data}>
      <div className="m-PowerBi-wrapper">
        <div className="m-PowerBi-container">
          {path_segment && (
            <CConsentBanner serviceName="PowerBI">
              <iframe
                className="m-PowerBi-iframe"
                title="Power BI Report"
                data-usercentrics="PowerBI"
                src={path_segment}
                allowFullScreen="true"
              ></iframe>
            </CConsentBanner>
          )}
        </div>
      </div>
    </Section>
  )
}

export default MPowerBi
